import { lazy } from 'react';
import { Route } from '../models/routes';

const NotFound = lazy(() => import('../pages/NotFound'));

export const notFoundRoutes: Route[] = [
  {
    path: '/',
    component: NotFound,
  },
  {
    path: '*',
    component: NotFound,
  },
];
